import React, { type ComponentProps, forwardRef } from 'react';
import styled from '@emotion/styled';
import { typography } from 'styled-system';

import { componentVariant } from '../../internal/styles/componentVariant';
import sx from '../../internal/styles/sx';
import Typography from '../Typography';
import type { BodyProps } from './types';

const StyledBody = styled(Typography)<BodyProps>(
  typography,
  componentVariant({
    prop: 'type',
    variants: {
      base: {
        fontSize: 'bodies.base',
        lineHeight: 'bodies.base',
        letterSpacing: 'body.base',
      },
      small: {
        fontSize: 'bodies.small',
        lineHeight: 'bodies.small',
        letterSpacing: 'body.small',
      },
      xSmall: {
        fontSize: 'bodies.xSmall',
        lineHeight: 'bodies.xSmall',
        letterSpacing: 'body.xSmall',
      },
      xxSmall: {
        fontSize: 'bodies.xxSmall',
        lineHeight: 'bodies.xxSmall',
        letterSpacing: 'body.xxSmall',
      },
    },
  }),
  ({ inline }) => (inline ? { display: 'inline' } : { display: 'block' }),
  sx
);

const Body = forwardRef<HTMLDivElement, ComponentProps<typeof StyledBody>>(
  (props, ref) => <StyledBody as="div" {...props} ref={ref} />
);

export default Body;
